import React from 'react';
import { roundFloat } from 'src/core/utils/formater';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export const customSummary = [
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'left', word: 'Нийт:' },
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'right', value: 'orlogo' },
  { align: 'right', value: 'suutgawal_zohih' },
  { align: 'right', value: '' },
  { align: 'right', value: 'suutgasan_tatvar' },
  { align: 'right', value: 'hunguluh_tatvar' },
  { align: 'right', value: '' },
  { align: 'right', value: 'suutgasan_alban_tatvar' },
  { align: 'right', value: '' },
];

export const MulticustomSummary = [
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'right', value: '' },
  { align: 'left', word: 'Нийт:' },
  { align: 'right', value: '' },
  { align: 'right', value: 'orlogo' },
  { align: 'right', value: 'suutgawal_zohih' },
  { align: 'right', value: '' },
  { align: 'right', value: 'suutgasan_tatvar' },
  { align: 'right', value: 'hunguluh_tatvar' },
  { align: 'right', value: 'suutgasan_alban_tatvar' },
  { align: 'right', value: '' },
];

export const columns = ({ showEditModal, shouldRenderEditColumn }) => {
  const cols = [
    {
      title: 'Татвар төлөгчийн дугаар',
      dataIndex: 'ttd',
      align: 'center',
      width: 150,
      fixed: 'left',
    },
    {
      title: 'Овог',
      dataIndex: 'ovog',
      align: 'right',
      width: 150,
      className: 'cell-left-border',
    },
    {
      title: 'Нэр',
      dataIndex: 'ner',
      align: 'right',
      width: 150,
    },
    {
      title: 'Улсын нэрс',
      dataIndex: 'uls_ners',
      align: 'right',
      width: 150,
    },
    {
      title: 'Орлогын төрөл',
      dataIndex: 'orlogon_turul',
      align: 'right',
      width: 150,
    },
    {
      title: 'Орлого',
      dataIndex: 'orlogo',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Суутгавал зохих',
      dataIndex: 'suutgawal_zohih',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хувь',
      dataIndex: 'huvi',
      align: 'right',
      width: 150,
      render: (_) => `${roundFloat(_)}%`,
    },
    {
      title: 'Суутгасан татвар',
      dataIndex: 'suutgasan_tatvar',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Хөнгөлөх татвар',
      dataIndex: 'hunguluh_tatvar',
      align: 'right',
      width: 150,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Суутгуулсан албан татвар',
      dataIndex: 'suutgasan_alban_tatvar',
      align: 'right',
      width: 180,
      render: (_) => roundFloat(_),
    },
    {
      title: 'Сертификаттай эсэх',
      dataIndex: 'certificate',
      align: 'center',
      width: 150,
      render: (_) => (_ ? 'Тийм' : 'Үгүй'),
    },
  ];
  if (shouldRenderEditColumn) {
    const editColumn = {
      title: '',
      dataIndex: 'edit_huuli_7_1_2',
      align: 'center',
      width: 50,
      render: (_, row) => (
        <Tooltip title="Засварлах">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => showEditModal(row)}
          />
        </Tooltip>
      ),
    };

    // Insert after the huuli_7_1_2 column (index 4)
    cols.splice(10, 0, editColumn); // inserts at position 5
  }

  return cols;
};
